import React from 'react';
import './RingLoader.css';
import { useTheme } from '../../../hooks/useTheme';
const RingLoader = () => {
  const { theme, setTheme } = useTheme()
  return (
    <div className='loader'>
      <div className="ring-loader">
      </div>
      <div className="ring-loader1">
      </div>
      <div className="ring-loader2">
      </div>
      <div className='loader-hole'>
        Загрузка
      </div>
      <div className='loader-hole1'>
      </div>
      <div className='loader-hole2'>
      </div>
    </div>
  );
}

export default RingLoader;
